
const env = import.meta.env;
const DEBUG = Boolean(env.VITE_APP_DEBUG==='true')

if(!DEBUG){
    console.log = function () {};
}

export default DEBUG;